import Events from "@components/Events"
import Ship from "@components/Ship"
import { BigHeading } from "@components/SiteShell"
import * as m from "@paraglide/messages"
import type { CalendarEventsResponse, SupportedLocale as Lang } from "@site-types/site"

export function CalendarPage({ events, locale }: { events: CalendarEventsResponse; locale: Lang }) {
  return (
    <div className="events-container">
      <BigHeading>
        {(m.calendar_heading_label({}, { locale: locale }) || "Watch Now").toUpperCase()}
      </BigHeading>
      <BigHeading variant="h3">
        {m.calendar_events({}, { locale: locale }) || "Events by Playbrain"}
      </BigHeading>
      <Events {...events} />
      <Ship
        ammoBomb={m.calendar_ship_ammo_bomb({}, { locale: locale }) || "BOMB"}
        ammoLaser={m.calendar_ship_ammo_laser({}, { locale: locale }) || "LASER"}
        ammoRapid={m.calendar_ship_ammo_rapid({}, { locale: locale }) || "RAPID"}
        ammoSpread={m.calendar_ship_ammo_spread({}, { locale: locale }) || "SPREAD"}
        controls={
          m.calendar_ship_controls({}, { locale: locale }) || "← → move • SPACE / click shoot • Q E ammo"
        }
      />
    </div>
  )
}
